import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'

class UserSubscriptionsModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: this.props.isModalOpen,
    }

    this.onSelectionClick = this.onSelectionClick.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
  }

  onSubmitSuccess(value) {
    Cookies.set(this.props.modalClosedCookieKey, true, { expires: 1, path: '/' })
    Cookies.set(this.props.lastSeenCookieKey, new Date().toISOString())

    this.setState({ modalIsOpen: false })

    if (value === 'opt_in') {
      App.events.publish('app:notification:flash:success', 'Your preferences have been saved.')
    }
  }

  onSelectionClick(value) {
    axios.put('/api/internal/users/update-gdpr-answer', { answer: value })
      .then((value) => this.onSubmitSuccess(value))
      .catch((error) => {})
  }

  render() {
    const infoBlocks = [
      {
        iconClass: 'percent',
        title: 'Sale and Bonus CGTrader credit campaign announcements',
        paragraph: 'Be the first to find out about great discounts and don’t miss the chance to use bonus credits.',
      },
      {
        iconClass: 'newspaper',
        title: 'Community news',
        paragraph: 'Don’t miss new features, competitions and products on CGTrader.',
      },
      {
        iconClass: 'star',
        title: 'Personalised offers',
        paragraph: 'Find exactly what you want for the best price on the market.',
      },
    ]

    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="modal--full modal--light modal--user-subscriptions">
          <button aria-hidden="true" className="btn btn--transparent modal--close" onClick={() => this.onSelectionClick('opt_out')}>
            <Icon type={['far', 'times']} notSpaced color="grey" size="lg" />
          </button>
          <div className="l-inner-large">
            <div className="modal-header u-text-center">
              <div className="modal-title">Are you on top of things at CGTrader?</div>
              <p className="modal-subtitle">Subscribe to our newsletter and be the first to hear about:</p>
            </div>
            <div className="modal-content u-text-center">
              <div className="row">
                {infoBlocks.map((block) => (
                  <div className="col-12 col-sm-4" key={block.title}>
                    <Icon type={['fal', block.iconClass]} notSpaced color="green-dark" />
                    <div className="modal-content__title">{block.title}</div>
                    <p>{block.paragraph}</p>
                  </div>
                ))}
              </div>
              <div className="row modal-actions">
                <div className="col-12">
                  <div>
                    <button className="btn btn-outline-primary u-mr10" onClick={() => this.onSelectionClick('opt_out')}>
                      Unsubscribe
                    </button>
                    <button className="btn btn-primary btn-fat" onClick={() => this.onSelectionClick('opt_in')}>
                      Subscribe
                    </button>
                  </div>
                  <div className="explanation-text u-mt10">
                    You can change your subscription preferences at any time in
                    the <a
                      href="https://www.cgtrader.com/profile/settings"
                      className="link--primary-dark"
                      target="_blank"
                    >account settings
                    </a>. See
                    our <a
                      href="https://www.cgtrader.com/pages/privacy-policy"
                      className="link--primary-dark"
                      target="_blank"
                    >Privacy Policy
                    </a> for more information.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

UserSubscriptionsModal.propTypes = {
  lastSeenCookieKey: PropTypes.string.isRequired,
  modalClosedCookieKey: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
}

export default UserSubscriptionsModal
